export default "/projects/enervent/custom/themes/100x100/assets/images/vendor/leaflet/dist/marker-shadow.png?a0c6cc1401c107b501efee6477816891";